import {useCallback} from 'react';
import {useParserState} from './useParserState';

export interface UseTextParserResult {
    parse: (file: File) => Promise<string>;
    loading: boolean;
    error: Error | null;
}

export function useTextParser(): UseTextParserResult {
    const {loading, error, wrap} = useParserState();

    const parse = useCallback(
        (file: File): Promise<string> =>
            wrap(
                () =>
                    new Promise((resolve, reject) => {
                        const reader = new FileReader();
                        reader.onload = (e) => {
                            const content = e.target?.result;
                            if (typeof content === 'string') resolve(content);
                            else reject(new Error('Failed to read file as text'));
                        };
                        reader.onerror = () => reject(reader.error ?? new Error('FileReader error'));
                        reader.readAsText(file);
                    })
            ),
        [wrap]
    );

    return {parse, loading, error};
}
